import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/cnae';

export default {
  buscarCnae: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarCnaesPorSubclasse: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar/subclasse`, { params });
  },
};
